import { render } from "./CaptureModal.vue?vue&type=template&id=687e6843"
import script from "./CaptureModal.vue?vue&type=script&lang=js"
export * from "./CaptureModal.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__